export default __webpack_public_path__ + "static/media/NCVanuatu.78f331c1.png";